import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ADD_ID } from '@documalis/_const/const';

@Injectable()
export class TabPanelHandler {
  public lastOpenedTabIndex = 0;
  public itemsSelected: any = [];
  protected _multiSelect = false;
  public index = 0;

  public _event = {
    id: -1
  };

  public displayWait = false;
  public actionMessage = '';
  private addMessage = '';

  constructor(protected translate: TranslateService) {
    this.itemsSelected = [];
    this.actionMessage = this.translate.instant('Update_In');
    this.addMessage = this.translate.instant('Add');
  }

  isAlreadySelected(id) {
    let _i = this.itemsSelected.length;
    while (_i--) {
      if (this.itemsSelected[_i].id === id) {
        return true;
      }
    }
    return false;
  }

  add(event) {
    if (!this.isAlreadySelected(ADD_ID)) {
      this.addElement(ADD_ID, this.addMessage);
    }
  }

  addElement(id, label, reference = null) {
    this.index = this.index + 1;
    this.itemsSelected.push({
      id: id,
      _label: label,
      reference: reference,
      index: this.itemsSelected.length + 1
    });
    this.index = this.itemsSelected.length;
  }

  closeTabsheet(event) {
    if (event.id !== undefined) {
      this.itemsSelected = [
        ...this.itemsSelected.filter(item => {
          return item.id !== event.id;
        })
      ];
    } else {
      // Fermeture avec la croix
      this.itemsSelected = [
        ...this.itemsSelected.filter(item => {
          if (item.index !== event.index) {
            return item;
          }
        })
      ];
    }
    // Renumérotation des index
    let i;
    for (i = 0; i < this.itemsSelected.length; i++) {
      this.itemsSelected[i].index = i + 1;
    }
  }

  execClose(event) {
    if (event.close) {
      event.close();
    }
  }

}
